import UsesFeatureFlags from '@/mixins/auth/UsesFeatureFlags'

export default {
  mixins: [ UsesFeatureFlags ],
  computed: {
    bookingNotificationCount () {
      if (!this.authenticatedUser) {
        return 0
      }
      return this.authenticatedUser.stats.bookingAlerts + (this.authenticatedUser.stats.bookingActive ? 1 : 0)
    },
    bookingRequestActions () {
      if (!this.authenticatedUser) {
        return 0
      }
      return this.authenticatedUser.stats.bookingAlerts
    },
    groupAdminLinks () {
      if (!this.authenticatedUser) {
        return 0
      }

      const kintellGroupAdmin = this.authenticatedUser?.kintellGroupAdmin

      // Show group admin menu only for Kintellers
      if ((kintellGroupAdmin && kintellGroupAdmin.length) && this.isExperimentsEnabled) {
        return {
          name: this.$t('app.pages.groupAdmin.title'),
          link: '/my-kintell/my-groups/facilitate-booking',
          icon: 'groupAdmin',
          iconSize: 20,
          sub: [
            // Commented codes will be required on future releases
            // {
            //   name: 'Usage Stats',
            //   link: '/my-kintell/my-groups'
            // },
            // {
            //   name: 'Members',
            //   link: '/my-kintell/my-groups/group-members'
            // },
            {
              name: 'Facilitate a booking',
              link: '/my-kintell/my-groups/facilitate-booking'
            },
            // {
            //   name: 'Add a batch booking',
            //   link: '/my-kintell/my-groups/batch-bookings'
            // },
          ]
        }
      }

      return ''
    },
    dashboardLinks () {
      // unauthenticated user don't need dashboard links
      if (!this.authenticatedUser) {
        return []
      }
      const kintellCardSection = {
        // if they have a pending card we use Kintell Cards so we can fit the chip
        name: this.$t('app.pages.myKintellCards.title'),
        link: '/my-kintell/kintell-cards',
        icon: 'edit',
        iconSize: 20,
        alerts: this.authenticatedUser.stats.kintellCardAwaitingAmendment ? 1 : 0,
      }
      if (this.authenticatedUser.kintellGroups.length > 0) {
        const groupLinks = this.authenticatedUser.kintellGroups.map(group => {
          return {
            name: group.name,
            link: '/my-kintell/kintell-cards/' + group.id,
          }
        })
        kintellCardSection.sub = [
          {
            name: 'Kintell',
            link: '/my-kintell/kintell-cards',
            alerts: this.authenticatedUser.stats.kintellCardAwaitingAmendment ? 1 : 0,
          },
          ...groupLinks,
        ]
      }
      return [
        {
          name: this.$t('app.pages.dashboard.title'),
          link: '/my-kintell/dashboard',
          icon: 'overview',
          iconSize: 16,
        },
        {
          name: 'Bookings',
          link: '/my-kintell/bookings',
          icon: 'bookings',
          iconSize: 19,
          alerts: this.bookingNotificationCount,
          sub: [
            {
              name: 'Confirmed',
              link: '/my-kintell/bookings',
              alerts: this.authenticatedUser.stats.bookingActive ? 1 : 0
            },
            {
              name: 'Requests',
              link: '/my-kintell/bookings/requests',
              alerts: this.bookingRequestActions,
            },
            {
              name: 'Archive',
              link: '/my-kintell/bookings/archive',
            },
            {
              name: 'Initiate a Booking',
              link: '/my-kintell/bookings/initiate',
            },
          ]
        },
        {
          ...kintellCardSection
        },
        {
          name: this.$t('app.pages.calendar.title'),
          link: '/my-kintell/my-calendar',
          icon: 'time',
          iconSize: 20,
          sub: [
            {
              name: 'Calendar view',
              link: '/my-kintell/my-calendar'
            },
            {
              name: 'Working hours',
              link: '/my-kintell/my-calendar/working-hours'
            },
            {
              name: 'Sync settings',
              link: '/my-kintell/my-calendar/sync-settings'
            },
            // {
            //   name: 'Snooze',
            //   link: ''
            // },
          ]
        },
        { ...this.groupAdminLinks },
        {
          name: this.$t('app.pages.myRewards.title'),
          link: '/my-kintell/my-rewards',
          icon: 'rewards',
          iconSize: 19,
        },
        {
          name: this.$t('app.pages.credits.title'),
          link: '/my-kintell/credits',
          icon: 'trophy',
          iconSize: 18,
        },
        {
          name: this.$t('app.pages.favourites.title'),
          link: '/my-kintell/favourites',
          icon: 'bookmark',
          iconSize: 20,
          sub: [
            {
              name: 'Public cards',
              link: '/my-kintell/favourites'
            },
            {
              name: 'Private cards',
              link: '/my-kintell/favourites/private'
            },
          ]
        },
        {
          name: 'My Account',
          link: '/my-kintell/my-details',
          icon: 'cog',
          iconSize: 21,
          alerts: this.authenticatedUser.stats.myDetailsAlerts,
          sub: [
            {
              name: 'My profile',
              link: '/my-kintell/my-details',
              alerts: this.authenticatedUser.stats.myDetailsProfileAlerts,
            },
            {
              name: 'Advisor settings',
              link: '/my-kintell/my-details/advisor-settings'
            },
            {
              name: 'Billing',
              link: '/my-kintell/my-details/billing',
              alerts: this.authenticatedUser.stats.myDetailsPayoutAlerts,
            },
          ]
        },
      ]
    },
  }
}
